import React from "react";
import MealsStructure from "../meal/MealsStructure";
import SearchNButtons from "../../common-components/SearchNButtons";

const DdFilters = ({
  filterType,
  ddFilters,
  setDdFilters,
  searchFilterApplied,
  onClickSearch,
  handleKeyPress,
}) => {
  return (
    <div className="flexSpacebetween dietDashboardFilters mt30">
      <MealsStructure
        text={`${filterType ? filterType?.replace(/_/g, " ") : "All Members"}`}
      />

      <SearchNButtons
        pageName={"diet-dashboard"}
        filters={ddFilters}
        setFilters={setDdFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        handleKeyPress={handleKeyPress}
      />
    </div>
  );
};

export default DdFilters;
